import { Controller } from "stimulus"

// Toggle visibility of content sections.
//
// Usage (basic show/hide):
//   .div{"data-controller" => "toggle"}
//     %button{"data-action" => "click->toggle#toggle"} Show/Hide
//     .div{"data-toggle-target" => "content", class: "d-none"}
//       Content here
//
// Usage (with custom CSS class):
//   .div{"data-controller" => "toggle", "data-toggle-class-value" => "visually-hidden"}
//     %button{"data-action" => "click->toggle#toggle"} Toggle
//     .div{"data-toggle-target" => "content"}
//       Content here
//
export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { class: String }

  connect() {
    if (!this.hasClassValue) this.classValue = "d-none"
  }

  toggle() {
    this.contentTargets.forEach(function(el) {
      el.classList.toggle(this.classValue)
    }.bind(this))

    // Rotate icon if present (e.g. chevron)
    this.iconTargets.forEach(function(el) {
      el.classList.toggle("fa-rotate-180")
    })
  }

  show() {
    this.contentTargets.forEach(function(el) {
      el.classList.remove(this.classValue)
    }.bind(this))
  }

  hide() {
    this.contentTargets.forEach(function(el) {
      el.classList.add(this.classValue)
    }.bind(this))
  }
}
